/* eslint-disable */
//
// DO NOT MODIFY ME. This code is automatically generated. Execute bb generate-graphql to update me
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '@graphql/utils/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Long: any;
  Timestamp: any;
};

export type AsinMetadataEntry = {
  asin: Scalars['String'];
  buyable?: Maybe<Scalars['Boolean']>;
  capacityUnitPerFacing?: Maybe<CapacityUnitPerFacing>;
  dimensions?: Maybe<Dimensions>;
  ean?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isSearchable?: Maybe<Scalars['Boolean']>;
  jumbleFactor?: Maybe<Scalars['Float']>;
  maxProductsInLaneForAF?: Maybe<Scalars['Int']>;
  menuImage?: Maybe<Scalars['String']>;
  merchandisingRestrictions?: Maybe<Array<Maybe<Scalars['String']>>>;
  ourPrice?: Maybe<Currency>;
  packageVariantsImage?: Maybe<Scalars['String']>;
  performanceData?: Maybe<PerformanceData>;
  plu?: Maybe<Scalars['String']>;
  procurable?: Maybe<Scalars['Boolean']>;
  productStackableForAtlas?: Maybe<Scalars['String']>;
  productStackableForLWP?: Maybe<Scalars['String']>;
  receiptImage?: Maybe<Scalars['String']>;
  springTensionForAF?: Maybe<Scalars['Int']>;
  techCompatibilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  temperatureRating?: Maybe<TemperatureRating>;
  tidyOrientations?: Maybe<Array<Maybe<TidyOrientation>>>;
  title?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<UnitPrice>;
  upc?: Maybe<Scalars['String']>;
  upce?: Maybe<Scalars['String']>;
  uph?: Maybe<Uph>;
  weightInGrams?: Maybe<Scalars['Float']>;
};

export type AssortmentEntry = {
  asin: Scalars['String'];
  asinMetadata?: Maybe<AsinMetadataEntry>;
  endTime: Scalars['Timestamp'];
  entryId: Scalars['String'];
  facingUnits: Scalars['Long'];
  fohCapacity: Scalars['Long'];
  isDraft: Scalars['Boolean'];
  macroplanogramId: Scalars['String'];
  recommendedAction?: Maybe<AssortmentEntryRecommendation>;
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
  subcategoryId: Scalars['String'];
};

export enum AssortmentEntryAction {
  Add = 'ADD',
  Keep = 'KEEP',
  Notactionable = 'NOTACTIONABLE',
  Remove = 'REMOVE'
}

export type AssortmentEntryRecommendation = {
  action: AssortmentEntryAction;
  note?: Maybe<Scalars['String']>;
};

export type AssortmentFacing = {
  asin: Scalars['String'];
  facingUnits: Scalars['Long'];
  fohCapacity: Scalars['Long'];
  subcategoryId: Scalars['String'];
};

export type AssortmentFacingUpdate = {
  entryId: Scalars['String'];
  facingUnits: Scalars['Long'];
  fohCapacity: Scalars['Long'];
};

export type AssortmentSwap = {
  addAssortment?: InputMaybe<Array<AssortmentFacing>>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type AssortmentSwapRecommendations = {
  facingUnitsToRemove: Scalars['Long'];
  macroplanogramId: Scalars['String'];
  maxFacingUnits: Scalars['Long'];
  occupiedFacingUnits: Scalars['Long'];
  swapRecommendations: Array<AssortmentEntry>;
};

export type AttributeData = {
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
  itemId: Scalars['String'];
  itemIdType: Scalars['String'];
  metadata: Metadata;
};

export type BatchSwapAssortmentAcrossZoneInput = {
  swapAssortmentInputList: Array<SwapAssortmentInput>;
};

export type BatchSwapAssortmentAcrossZoneResponse = {
  errorMap: Array<MapError>;
};

export type CmtError = {
  errorMessage: Scalars['String'];
  errorType?: Maybe<ErrorType>;
};

export type CapacityUnitPerFacing = {
  capacity?: Maybe<Scalars['Int']>;
  errorMsg?: Maybe<Scalars['String']>;
  jumbleFactor?: Maybe<Scalars['Float']>;
};

export type Category = {
  categoryId: Scalars['String'];
  categoryName: Scalars['String'];
  extraDimensions?: Maybe<Array<Scalars['String']>>;
};

export type ChildAsinEntry = {
  asin?: Maybe<Scalars['String']>;
  buyUnits?: Maybe<Scalars['Long']>;
  orderDate?: Maybe<Scalars['Timestamp']>;
  salesUnits?: Maybe<Scalars['Long']>;
  size: Scalars['String'];
};

export type ChildIdentifierInput = {
  asin?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
};

export type ChildInput = {
  buyUnits?: InputMaybe<Scalars['Long']>;
  id: ChildIdentifierInput;
  orderDate?: InputMaybe<Scalars['Timestamp']>;
  salesUnits?: InputMaybe<Scalars['Long']>;
};

export type CreateCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  categoryName: Scalars['String'];
  extraDimensions?: InputMaybe<Array<Scalars['String']>>;
  productGroup: Scalars['String'];
};

export type CreateCategoryResponse = {
  category?: Maybe<Category>;
  error?: Maybe<CmtError>;
};

export type CreateSubcategoryInput = {
  categoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type CreateSubcategoryResponse = {
  error?: Maybe<CmtError>;
  subcategory?: Maybe<Subcategory>;
};

export type Currency = {
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Dimensions = {
  heightInMillimeters?: Maybe<Scalars['Float']>;
  lengthInMillimeters?: Maybe<Scalars['Float']>;
  widthInMillimeters?: Maybe<Scalars['Float']>;
};

export enum DoorType {
  All = 'ALL',
  Cold = 'COLD',
  Hot = 'HOT'
}

export type ErrorMsg = {
  field: Scalars['String'];
  reason: Scalars['String'];
};

export enum ErrorType {
  ClientError = 'ClientError',
  ConflictError = 'ConflictError',
  DependencyError = 'DependencyError',
  IllegalArgumentError = 'IllegalArgumentError',
  InternalServerError = 'InternalServerError',
  MissingAttributeError = 'MissingAttributeError',
  PartialRequestError = 'PartialRequestError',
  RetryableError = 'RetryableError',
  UserPermissionError = 'UserPermissionError'
}

export type FailedItem = {
  error?: Maybe<SelectionEntryError>;
  itemIdWithType: ItemIdWithType;
  selectionEntryId?: Maybe<Scalars['String']>;
};

export type FailedPassItem = {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  error?: Maybe<PassError>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
};

export type FailedSelectionEntry = {
  error?: Maybe<SelectionEntryError>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  optimisticLockId?: Maybe<Scalars['Long']>;
  selectionEntryId: Scalars['String'];
};

export type FixtureConfig = {
  facings: Scalars['Int'];
  fixtureType: Scalars['String'];
  id: Scalars['String'];
};

export type FixtureConfigInput = {
  facings: Scalars['Int'];
  fixtureType: Scalars['String'];
  id: Scalars['String'];
};

export type FixtureData = {
  categories?: Maybe<Array<Scalars['String']>>;
  department?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isAgile?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  rotation?: Maybe<Scalars['Float']>;
  translation?: Maybe<Array<Scalars['Float']>>;
  width?: Maybe<Scalars['Float']>;
};

export type Floorplan = {
  fixtures: Array<FixtureData>;
  floorplanId?: Maybe<Scalars['String']>;
  goLiveDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GetAsinMetadataInput = {
  asinList: Array<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  zoneMapConfigId?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
};

export type GetAsinMetadataResponse = {
  asinMetadata?: Maybe<Array<AsinMetadataEntry>>;
  error?: Maybe<CmtError>;
};

export type GetAssortmentDiffInput = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramIds: Array<Scalars['String']>;
  productEntries: Array<ProductEntry>;
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetAssortmentDiffResponse = {
  assortmentRecommendations?: Maybe<Array<AssortmentEntry>>;
  error?: Maybe<CmtError>;
};

export type GetAssortmentSwapRecommendationsInput = {
  addAssortment?: InputMaybe<Array<AssortmentFacing>>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type GetAssortmentSwapRecommendationsResponse = {
  facingUnitsToRemove: Scalars['Long'];
  maxFacingUnits: Scalars['Long'];
  occupiedFacingUnits: Scalars['Long'];
  swapRecommendations: Array<AssortmentEntry>;
};

export type GetBatchAssortmentSwapRecommendationsInput = {
  batchAssortmentSwap: Array<AssortmentSwap>;
};

export type GetBatchAssortmentSwapRecommendationsResponse = {
  errorMap: Array<MapError>;
  swapRecommendations: Array<AssortmentSwapRecommendations>;
};

export type GetCategoryInput = {
  productGroup: Scalars['String'];
};

export type GetCategoryResponse = {
  category?: Maybe<Array<Category>>;
  error?: Maybe<CmtError>;
  subcategory?: Maybe<Array<Subcategory>>;
};

export type GetFloorplanInput = {
  date?: InputMaybe<Scalars['Timestamp']>;
  storeId: Scalars['String'];
};

export type GetFloorplanResponse = {
  error?: Maybe<CmtError>;
  floorplans?: Maybe<Array<Floorplan>>;
};

export type GetMacroAssortmentInput = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  includeFuture: Scalars['Boolean'];
  macroplanogramId?: InputMaybe<Scalars['String']>;
  maxResult?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetMacroAssortmentResponse = {
  assortment?: Maybe<Array<AssortmentEntry>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetMacroplanogramInput = {
  includeDraft: Scalars['Boolean'];
  includeFuture: Scalars['Boolean'];
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetMacroplanogramResponse = {
  macroplanogram?: Maybe<Array<MacroplanogramEntry>>;
};

export type GetProductAttributeInput = {
  attributeName: Scalars['String'];
  attributeValue?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  itemIdType?: InputMaybe<ItemIdType>;
  maxResults?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['String']>;
  scopeId: Scalars['String'];
  scopeType: ScopeType;
};

export type GetProductAttributeResponse = {
  attributes?: Maybe<Array<AttributeData>>;
  error?: Maybe<CmtError>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetProductGroupsResponse = {
  error?: Maybe<CmtError>;
  productGroups?: Maybe<Array<Maybe<ProductGroup>>>;
};

export type GetProgramStoresResponse = {
  error?: Maybe<CmtError>;
  stores?: Maybe<Array<Store>>;
};

export type GetUserInformationResponse = {
  alias?: Maybe<Scalars['String']>;
  allowedStyleMerchLocationGroup?: Maybe<Array<StyleMerchLocationGroup>>;
  error?: Maybe<CmtError>;
};

export type GetZoneConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
  zoneName: Scalars['String'];
};

export type GetZoneConfigResponse = {
  error?: Maybe<CmtError>;
  zone?: Maybe<ZoneConfig>;
};

export type GetZoneMapConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
};

export type GetZoneMapConfigResponse = {
  error?: Maybe<CmtError>;
  zoneMapConfig?: Maybe<ZoneMapConfig>;
};

export type Identity = {
  actorId: Scalars['String'];
  actorType: Scalars['String'];
};

export enum ItemIdType {
  Asin = 'ASIN',
  TeenAsin = 'TEEN_ASIN',
  VendorProduct = 'VENDOR_PRODUCT'
}

export type ItemIdWithType = {
  id: Scalars['String'];
  type: ItemIdType;
};

export type ItemIdWithTypeInput = {
  id: Scalars['String'];
  type: ItemIdType;
};

export type MacroplanogramEntry = {
  endTime: Scalars['Timestamp'];
  entryId: Scalars['String'];
  fixtureIds?: Maybe<Array<Scalars['String']>>;
  isCapacityOverrideAllowed?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  macroplanogramName?: Maybe<Scalars['String']>;
  maxFacingUnits: Scalars['Long'];
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
  storeSubcategories?: Maybe<Array<StoreSubcategory>>;
  zoneMapConfigId?: Maybe<Scalars['String']>;
};

export type MapError = {
  error: CmtError;
  key: Scalars['String'];
};

export type Metadata = {
  timestamp: Scalars['Timestamp'];
  updatedBy: Identity;
};

export type MonthAndYear = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type Mutation = {
  batchSwapAssortmentAcrossZone: BatchSwapAssortmentAcrossZoneResponse;
  createCategory: CreateCategoryResponse;
  createSubcategory: CreateSubcategoryResponse;
  promoteDraftZone: PromoteDraftZoneResponse;
  publishZone: PublishZoneResponse;
  putZoneMapConfig: PutZoneMapConfigResponse;
  swapAssortment: SwapAssortmentResponse;
  updateOrDeleteProductAttribute: UpdateOrDeleteProductAttributeResponse;
};


export type MutationBatchSwapAssortmentAcrossZoneArgs = {
  batchSwapAssortmentAcrossZoneInput?: InputMaybe<BatchSwapAssortmentAcrossZoneInput>;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput?: InputMaybe<CreateCategoryInput>;
};


export type MutationCreateSubcategoryArgs = {
  createSubcategoryInput?: InputMaybe<CreateSubcategoryInput>;
};


export type MutationPromoteDraftZoneArgs = {
  promoteDraftZoneInput?: InputMaybe<PromoteDraftZoneInput>;
};


export type MutationPublishZoneArgs = {
  publishZoneInput?: InputMaybe<PublishZoneInput>;
};


export type MutationPutZoneMapConfigArgs = {
  putZoneMapConfigInput?: InputMaybe<PutZoneMapConfigInput>;
};


export type MutationSwapAssortmentArgs = {
  swapAssortmentInput?: InputMaybe<SwapAssortmentInput>;
};


export type MutationUpdateOrDeleteProductAttributeArgs = {
  updateOrDeleteProductAttributeInput?: InputMaybe<UpdateOrDeleteProductAttributeInput>;
};

export type PassError = {
  errorMessage: Scalars['String'];
  errorType: PassErrorType;
};

export enum PassErrorType {
  AccessDeniedException = 'AccessDeniedException',
  DependencyFailure = 'DependencyFailure',
  NotFoundException = 'NotFoundException',
  StoreNotFoundException = 'StoreNotFoundException',
  UnauthorizedException = 'UnauthorizedException'
}

export type ProductEntry = {
  asin: Scalars['String'];
  subcategoryName?: InputMaybe<Scalars['String']>;
};

export type ProductGroup = {
  productGroupId: Scalars['String'];
  productGroupName: Scalars['String'];
};

export enum ProductRelationship {
  Fba = 'FBA',
  Plb = 'PLB',
  Retail = 'Retail'
}

export type PromoteDraftZoneInput = {
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type PromoteDraftZoneResponse = {
  error?: Maybe<CmtError>;
};

export type PublishZoneInput = {
  isDraft: Scalars['Boolean'];
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
  zoneMap: Array<Zone>;
  zoneMapConfigId?: InputMaybe<Scalars['String']>;
};

export type PublishZoneResponse = {
  error?: Maybe<CmtError>;
};

export type PutZoneMapConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
  zones?: InputMaybe<Array<ZoneConfigInput>>;
};

export type PutZoneMapConfigResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
  zoneMapConfigId?: Maybe<Scalars['String']>;
};

export type Query = {
  getAsinMetadata: GetAsinMetadataResponse;
  getAssortmentDiff: GetAssortmentDiffResponse;
  getAssortmentSwapRecommendations: GetAssortmentSwapRecommendationsResponse;
  getBatchAssortmentSwapRecommendations: GetBatchAssortmentSwapRecommendationsResponse;
  getCategory: GetCategoryResponse;
  getFloorplan: GetFloorplanResponse;
  getMacroAssortment: GetMacroAssortmentResponse;
  getMacroplanogram: GetMacroplanogramResponse;
  getProductAttribute: GetProductAttributeResponse;
  getProductGroups: GetProductGroupsResponse;
  getProgramStores: GetProgramStoresResponse;
  getUserInformation: GetUserInformationResponse;
  getZoneConfig: GetZoneConfigResponse;
  getZoneMapConfig: GetZoneMapConfigResponse;
};


export type QueryGetAsinMetadataArgs = {
  getAsinMetadataInput?: InputMaybe<GetAsinMetadataInput>;
};


export type QueryGetAssortmentDiffArgs = {
  getAssortmentDiffInput?: InputMaybe<GetAssortmentDiffInput>;
};


export type QueryGetAssortmentSwapRecommendationsArgs = {
  getAssortmentSwapRecommendationsInput?: InputMaybe<GetAssortmentSwapRecommendationsInput>;
};


export type QueryGetBatchAssortmentSwapRecommendationsArgs = {
  getBatchAssortmentSwapRecommendationsInput?: InputMaybe<GetBatchAssortmentSwapRecommendationsInput>;
};


export type QueryGetCategoryArgs = {
  getCategoryInput?: InputMaybe<GetCategoryInput>;
};


export type QueryGetFloorplanArgs = {
  getFloorplanInput?: InputMaybe<GetFloorplanInput>;
};


export type QueryGetMacroAssortmentArgs = {
  getMacroAssortmentInput?: InputMaybe<GetMacroAssortmentInput>;
};


export type QueryGetMacroplanogramArgs = {
  getMacroplanogramInput?: InputMaybe<GetMacroplanogramInput>;
};


export type QueryGetProductAttributeArgs = {
  getProductAttributeInput?: InputMaybe<GetProductAttributeInput>;
};


export type QueryGetZoneConfigArgs = {
  getZoneConfigInput?: InputMaybe<GetZoneConfigInput>;
};


export type QueryGetZoneMapConfigArgs = {
  getZoneMapConfigInput?: InputMaybe<GetZoneMapConfigInput>;
};

export enum ScopeType {
  ObfuscatedMarketplaceId = 'OBFUSCATED_MARKETPLACE_ID',
  ObfuscatedMarketplaceIdAndVendorCode = 'OBFUSCATED_MARKETPLACE_ID_AND_VENDOR_CODE',
  StoreId = 'STORE_ID'
}

export enum Season {
  Fall = 'Fall',
  Spring = 'Spring',
  Summer = 'Summer',
  Winter = 'Winter'
}

export type SeasonAndYear = {
  season: Season;
  year: Scalars['String'];
};

export type SelectionEntry = {
  asin?: Maybe<Scalars['String']>;
  asinMetadata?: Maybe<AsinMetadataEntry>;
  lastUpdatedTimestamp: Scalars['Timestamp'];
  optimisticLockId: Scalars['Long'];
  selectionEntryId: Scalars['String'];
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type SelectionEntryError = {
  errorMessage: Scalars['String'];
  errorType: SelectionEntryErrorType;
};

export enum SelectionEntryErrorType {
  BadRequestError = 'BadRequestError',
  CatalogNotFoundError = 'CatalogNotFoundError',
  DependencyError = 'DependencyError',
  DuplicateEntryError = 'DuplicateEntryError',
  RetryableError = 'RetryableError',
  SelectionEntryNotFoundError = 'SelectionEntryNotFoundError',
  UserPermissionError = 'UserPermissionError',
  ValidationError = 'ValidationError',
  VersionConflictError = 'VersionConflictError'
}

export type SelectionGroup = {
  selectionGroupId: Scalars['String'];
  selectionGroupName?: Maybe<Scalars['String']>;
};

export type SelectionResult = {
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  selectionMetadataName?: Maybe<Scalars['String']>;
};

export type Store = {
  launchDate?: Maybe<Scalars['String']>;
  storeId: Scalars['String'];
  warehouseId: Scalars['String'];
};

export type StoreSubcategory = {
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export enum StyleMerchLocationGroup {
  Men = 'Men',
  Other = 'Other',
  Women = 'Women'
}

export type Subcategory = {
  categoryId: Scalars['String'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SucceededItem = {
  itemIdWithType: ItemIdWithType;
  optimisticLockId: Scalars['Long'];
  selectionEntryId: Scalars['String'];
};

export type SucceededPassItem = {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
};

export type SwapAssortmentInput = {
  addAssortment: Array<AssortmentFacing>;
  assortmentFacingUpdates: Array<AssortmentFacingUpdate>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type SwapAssortmentResponse = {
  error?: Maybe<CmtError>;
};

export enum TemperatureRating {
  Ambient = 'AMBIENT',
  Chilled = 'CHILLED',
  Frozen = 'FROZEN'
}

export type TidyOrientation = {
  orientation?: Maybe<Scalars['String']>;
  rotation?: Maybe<Scalars['String']>;
  shelfTech?: Maybe<Scalars['String']>;
};

export type UnitPrice = {
  price?: Maybe<Currency>;
  unit?: Maybe<Scalars['String']>;
};

export type UpdateLocalAttributesResponse = {
  error?: Maybe<CmtError>;
  failedItems?: Maybe<Array<FailedItem>>;
  succeededItems?: Maybe<Array<SucceededItem>>;
};

export type UpdateOrDeleteItem = {
  attributeName: Scalars['String'];
  attributeValue?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
  scopeId: Scalars['String'];
  scopeType: ScopeType;
};

export type UpdateOrDeleteProductAttributeInput = {
  delete: Scalars['Boolean'];
  items: Array<UpdateOrDeleteItem>;
  update: Scalars['Boolean'];
};

export type UpdateOrDeleteProductAttributeResponse = {
  error?: Maybe<CmtError>;
  failedItems?: Maybe<Array<FailedPassItem>>;
  succeededItems?: Maybe<Array<SucceededPassItem>>;
};

export type UpdateSelectionEntryInput = {
  children: Array<ChildInput>;
  itemIdWithType: ItemIdWithTypeInput;
};

export type Uph = {
  uphl1?: Maybe<Scalars['String']>;
  uphl2?: Maybe<Scalars['String']>;
  uphl3?: Maybe<Scalars['String']>;
};

export type Zone = {
  department?: InputMaybe<Scalars['String']>;
  facings: Scalars['Long'];
  fixtureIds: Array<Scalars['String']>;
  name: Scalars['String'];
  subcategoryIds: Array<Scalars['String']>;
};

export type ZoneConfig = {
  fixtures?: Maybe<Array<FixtureConfig>>;
  name: Scalars['String'];
};

export type ZoneConfigInput = {
  fixtures?: InputMaybe<Array<FixtureConfigInput>>;
  name: Scalars['String'];
};

export type ZoneMapConfig = {
  name: Scalars['String'];
  zones?: Maybe<Array<ZoneConfig>>;
};

export type PerformanceData = {
  movingAvgSales13week?: Maybe<Scalars['Float']>;
  movingAvgSales26week?: Maybe<Scalars['Float']>;
  movingAvgSales52week?: Maybe<Scalars['Float']>;
  shrinkCost?: Maybe<Scalars['Float']>;
  shrinkPerOps?: Maybe<Scalars['Float']>;
  shrinkPerOps13week?: Maybe<Scalars['Float']>;
  shrinkPerOps26week?: Maybe<Scalars['Float']>;
  shrinkPerOps52week?: Maybe<Scalars['Float']>;
};

export type BatchSwapAssortmentAcrossZoneMutationVariables = Exact<{
  input?: InputMaybe<BatchSwapAssortmentAcrossZoneInput>;
}>;


export type BatchSwapAssortmentAcrossZoneMutation = { batchSwapAssortmentAcrossZone: { errorMap: Array<{ key: string, error: { errorMessage: string, errorType?: ErrorType | null } }> } };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { createCategory: { category?: { categoryId: string, categoryName: string, extraDimensions?: Array<string> | null } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type CreateSubcategoryMutationVariables = Exact<{
  input: CreateSubcategoryInput;
}>;


export type CreateSubcategoryMutation = { createSubcategory: { subcategory?: { subcategoryId: string, subcategoryName: string, categoryId: string } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type PromoteDraftZoneMutationVariables = Exact<{
  input?: InputMaybe<PromoteDraftZoneInput>;
}>;


export type PromoteDraftZoneMutation = { promoteDraftZone: { error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type PublishZoneMutationVariables = Exact<{
  input?: InputMaybe<PublishZoneInput>;
}>;


export type PublishZoneMutation = { publishZone: { error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type PutZoneMapConfigMutationVariables = Exact<{
  input: PutZoneMapConfigInput;
}>;


export type PutZoneMapConfigMutation = { putZoneMapConfig: { success: boolean, zoneMapConfigId?: string | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type SwapAssortmentMutationVariables = Exact<{
  input?: InputMaybe<SwapAssortmentInput>;
}>;


export type SwapAssortmentMutation = { swapAssortment: { error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAsinMetadataQueryVariables = Exact<{
  input: GetAsinMetadataInput;
}>;


export type GetAsinMetadataQuery = { getAsinMetadata: { asinMetadata?: Array<{ asin: string, title?: string | null, image?: string | null, procurable?: boolean | null, buyable?: boolean | null, temperatureRating?: TemperatureRating | null, capacityUnitPerFacing?: { capacity?: number | null, jumbleFactor?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetPrsDataQueryVariables = Exact<{
  input: GetAsinMetadataInput;
}>;


export type GetPrsDataQuery = { getAsinMetadata: { asinMetadata?: Array<{ asin: string, title?: string | null, image?: string | null, menuImage?: string | null, packageVariantsImage?: string | null, upc?: string | null, upce?: string | null, gtin?: string | null, ean?: string | null, plu?: string | null, techCompatibilities?: Array<string | null> | null, productStackableForAtlas?: string | null, productStackableForLWP?: string | null, springTensionForAF?: number | null, maxProductsInLaneForAF?: number | null, merchandisingRestrictions?: Array<string | null> | null, weightInGrams?: number | null, isSearchable?: boolean | null, unitPrice?: { unit?: string | null, price?: { unit?: string | null, value?: number | null } | null } | null, ourPrice?: { unit?: string | null, value?: number | null } | null, tidyOrientations?: Array<{ orientation?: string | null, rotation?: string | null, shelfTech?: string | null } | null> | null, dimensions?: { heightInMillimeters?: number | null, lengthInMillimeters?: number | null, widthInMillimeters?: number | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAssortmentDiffQueryVariables = Exact<{
  input: GetAssortmentDiffInput;
}>;


export type GetAssortmentDiffQuery = { getAssortmentDiff: { assortmentRecommendations?: Array<{ asin: string, entryId: string, startTime: any, endTime: any, subcategoryId: string, macroplanogramId: string, facingUnits: any, fohCapacity: any, asinMetadata?: { asin: string, title?: string | null, image?: string | null, procurable?: boolean | null, buyable?: boolean | null, temperatureRating?: TemperatureRating | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null, jumbleFactor?: number | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null, recommendedAction?: { action: AssortmentEntryAction, note?: string | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAssortmentSwapRecommendationsQueryVariables = Exact<{
  input: GetAssortmentSwapRecommendationsInput;
}>;


export type GetAssortmentSwapRecommendationsQuery = { getAssortmentSwapRecommendations: { facingUnitsToRemove: any, maxFacingUnits: any, occupiedFacingUnits: any, swapRecommendations: Array<{ asin: string, entryId: string, subcategoryId: string, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits: any, fohCapacity: any, asinMetadata?: { asin: string, title?: string | null, image?: string | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> } };

export type GetBatchAssortmentSwapRecommendationsQueryVariables = Exact<{
  input: GetBatchAssortmentSwapRecommendationsInput;
}>;


export type GetBatchAssortmentSwapRecommendationsQuery = { getBatchAssortmentSwapRecommendations: { swapRecommendations: Array<{ facingUnitsToRemove: any, maxFacingUnits: any, occupiedFacingUnits: any, macroplanogramId: string, swapRecommendations: Array<{ asin: string, entryId: string, subcategoryId: string, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits: any, fohCapacity: any, asinMetadata?: { asin: string, title?: string | null, image?: string | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> }>, errorMap: Array<{ key: string, error: { errorMessage: string, errorType?: ErrorType | null } }> } };

export type GetCategoryQueryVariables = Exact<{
  input?: InputMaybe<GetCategoryInput>;
}>;


export type GetCategoryQuery = { getCategory: { category?: Array<{ categoryId: string, categoryName: string, extraDimensions?: Array<string> | null }> | null, subcategory?: Array<{ subcategoryId: string, subcategoryName: string, categoryId: string }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetFloorplanQueryVariables = Exact<{
  input: GetFloorplanInput;
}>;


export type GetFloorplanQuery = { getFloorplan: { floorplans?: Array<{ floorplanId?: string | null, goLiveDate?: string | null, status?: string | null, fixtures: Array<{ id: string, model?: string | null, height?: number | null, width?: number | null, depth?: number | null, rotation?: number | null, translation?: Array<number> | null, department?: string | null, categories?: Array<string> | null, isAgile?: boolean | null }> }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetMacroAssortmentQueryVariables = Exact<{
  input: GetMacroAssortmentInput;
}>;


export type GetMacroAssortmentQuery = { getMacroAssortment: { paginationToken?: string | null, assortment?: Array<{ asin: string, entryId: string, subcategoryId: string, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits: any, fohCapacity: any, asinMetadata?: { asin: string, title?: string | null, image?: string | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> | null } };

export type GetMacroplanogramQueryVariables = Exact<{
  input: GetMacroplanogramInput;
}>;


export type GetMacroplanogramQuery = { getMacroplanogram: { macroplanogram?: Array<{ entryId: string, macroplanogramName?: string | null, startTime: any, endTime: any, storeId: string, fixtureIds?: Array<string> | null, maxFacingUnits: any, isCapacityOverrideAllowed?: boolean | null, isDraft?: boolean | null, zoneMapConfigId?: string | null, storeSubcategories?: Array<{ subcategoryName: string, subcategoryId: string }> | null }> | null } };

export type GetProductGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductGroupsQuery = { getProductGroups: { productGroups?: Array<{ productGroupId: string, productGroupName: string } | null> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetProgramStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramStoresQuery = { getProgramStores: { stores?: Array<{ storeId: string, warehouseId: string, launchDate?: string | null }> | null } };

export type GetUserInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInformationQuery = { getUserInformation: { alias?: string | null, allowedStyleMerchLocationGroup?: Array<StyleMerchLocationGroup> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetZoneMapConfigQueryVariables = Exact<{
  input: GetZoneMapConfigInput;
}>;


export type GetZoneMapConfigQuery = { getZoneMapConfig: { zoneMapConfig?: { name: string, zones?: Array<{ name: string, fixtures?: Array<{ id: string, fixtureType: string, facings: number }> | null }> | null } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };


export const BatchSwapAssortmentAcrossZoneDocument = `
    mutation batchSwapAssortmentAcrossZone($input: BatchSwapAssortmentAcrossZoneInput) {
  batchSwapAssortmentAcrossZone(batchSwapAssortmentAcrossZoneInput: $input) {
    errorMap {
      key
      error {
        errorMessage
        errorType
      }
    }
  }
}
    `;
export const useBatchSwapAssortmentAcrossZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchSwapAssortmentAcrossZoneMutation, TError, BatchSwapAssortmentAcrossZoneMutationVariables, TContext>) =>
    useMutation<BatchSwapAssortmentAcrossZoneMutation, TError, BatchSwapAssortmentAcrossZoneMutationVariables, TContext>(
      ['batchSwapAssortmentAcrossZone'],
      (variables?: BatchSwapAssortmentAcrossZoneMutationVariables) => fetcher<BatchSwapAssortmentAcrossZoneMutation, BatchSwapAssortmentAcrossZoneMutationVariables>(BatchSwapAssortmentAcrossZoneDocument, variables)(),
      options
    );
export const CreateCategoryDocument = `
    mutation createCategory($input: CreateCategoryInput!) {
  createCategory(createCategoryInput: $input) {
    category {
      categoryId
      categoryName
      extraDimensions
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>) =>
    useMutation<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>(
      ['createCategory'],
      (variables?: CreateCategoryMutationVariables) => fetcher<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, variables)(),
      options
    );
export const CreateSubcategoryDocument = `
    mutation createSubcategory($input: CreateSubcategoryInput!) {
  createSubcategory(createSubcategoryInput: $input) {
    subcategory {
      subcategoryId
      subcategoryName
      categoryId
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useCreateSubcategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSubcategoryMutation, TError, CreateSubcategoryMutationVariables, TContext>) =>
    useMutation<CreateSubcategoryMutation, TError, CreateSubcategoryMutationVariables, TContext>(
      ['createSubcategory'],
      (variables?: CreateSubcategoryMutationVariables) => fetcher<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>(CreateSubcategoryDocument, variables)(),
      options
    );
export const PromoteDraftZoneDocument = `
    mutation promoteDraftZone($input: PromoteDraftZoneInput) {
  promoteDraftZone(promoteDraftZoneInput: $input) {
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const usePromoteDraftZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PromoteDraftZoneMutation, TError, PromoteDraftZoneMutationVariables, TContext>) =>
    useMutation<PromoteDraftZoneMutation, TError, PromoteDraftZoneMutationVariables, TContext>(
      ['promoteDraftZone'],
      (variables?: PromoteDraftZoneMutationVariables) => fetcher<PromoteDraftZoneMutation, PromoteDraftZoneMutationVariables>(PromoteDraftZoneDocument, variables)(),
      options
    );
export const PublishZoneDocument = `
    mutation publishZone($input: PublishZoneInput) {
  publishZone(publishZoneInput: $input) {
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const usePublishZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishZoneMutation, TError, PublishZoneMutationVariables, TContext>) =>
    useMutation<PublishZoneMutation, TError, PublishZoneMutationVariables, TContext>(
      ['publishZone'],
      (variables?: PublishZoneMutationVariables) => fetcher<PublishZoneMutation, PublishZoneMutationVariables>(PublishZoneDocument, variables)(),
      options
    );
export const PutZoneMapConfigDocument = `
    mutation putZoneMapConfig($input: PutZoneMapConfigInput!) {
  putZoneMapConfig(putZoneMapConfigInput: $input) {
    success
    zoneMapConfigId
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const usePutZoneMapConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PutZoneMapConfigMutation, TError, PutZoneMapConfigMutationVariables, TContext>) =>
    useMutation<PutZoneMapConfigMutation, TError, PutZoneMapConfigMutationVariables, TContext>(
      ['putZoneMapConfig'],
      (variables?: PutZoneMapConfigMutationVariables) => fetcher<PutZoneMapConfigMutation, PutZoneMapConfigMutationVariables>(PutZoneMapConfigDocument, variables)(),
      options
    );
export const SwapAssortmentDocument = `
    mutation swapAssortment($input: SwapAssortmentInput) {
  swapAssortment(swapAssortmentInput: $input) {
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useSwapAssortmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SwapAssortmentMutation, TError, SwapAssortmentMutationVariables, TContext>) =>
    useMutation<SwapAssortmentMutation, TError, SwapAssortmentMutationVariables, TContext>(
      ['swapAssortment'],
      (variables?: SwapAssortmentMutationVariables) => fetcher<SwapAssortmentMutation, SwapAssortmentMutationVariables>(SwapAssortmentDocument, variables)(),
      options
    );
export const GetAsinMetadataDocument = `
    query GetAsinMetadata($input: GetAsinMetadataInput!) {
  getAsinMetadata(getAsinMetadataInput: $input) {
    asinMetadata {
      asin
      capacityUnitPerFacing {
        capacity
        jumbleFactor
        errorMsg
      }
      title
      image
      uph {
        uphl1
        uphl2
        uphl3
      }
      procurable
      buyable
      temperatureRating
      performanceData {
        shrinkCost
        shrinkPerOps
        shrinkPerOps13week
        shrinkPerOps26week
        shrinkPerOps52week
        movingAvgSales13week
        movingAvgSales26week
        movingAvgSales52week
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetAsinMetadataQuery = <
      TData = GetAsinMetadataQuery,
      TError = unknown
    >(
      variables: GetAsinMetadataQueryVariables,
      options?: UseQueryOptions<GetAsinMetadataQuery, TError, TData>
    ) =>
    useQuery<GetAsinMetadataQuery, TError, TData>(
      ['GetAsinMetadata', variables],
      fetcher<GetAsinMetadataQuery, GetAsinMetadataQueryVariables>(GetAsinMetadataDocument, variables),
      options
    );
export const useInfiniteGetAsinMetadataQuery = <
      TData = GetAsinMetadataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAsinMetadataQueryVariables,
      variables: GetAsinMetadataQueryVariables,
      options?: UseInfiniteQueryOptions<GetAsinMetadataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAsinMetadataQuery, TError, TData>(
      ['GetAsinMetadata.infinite', variables],
      (metaData) => fetcher<GetAsinMetadataQuery, GetAsinMetadataQueryVariables>(GetAsinMetadataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetPrsDataDocument = `
    query getPrsData($input: GetAsinMetadataInput!) {
  getAsinMetadata(getAsinMetadataInput: $input) {
    asinMetadata {
      asin
      title
      image
      unitPrice {
        unit
        price {
          unit
          value
        }
      }
      ourPrice {
        unit
        value
      }
      menuImage
      packageVariantsImage
      upc
      upce
      gtin
      ean
      plu
      techCompatibilities
      productStackableForAtlas
      productStackableForLWP
      springTensionForAF
      maxProductsInLaneForAF
      tidyOrientations {
        orientation
        rotation
        shelfTech
      }
      merchandisingRestrictions
      dimensions {
        heightInMillimeters
        lengthInMillimeters
        widthInMillimeters
      }
      weightInGrams
      isSearchable
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetPrsDataQuery = <
      TData = GetPrsDataQuery,
      TError = unknown
    >(
      variables: GetPrsDataQueryVariables,
      options?: UseQueryOptions<GetPrsDataQuery, TError, TData>
    ) =>
    useQuery<GetPrsDataQuery, TError, TData>(
      ['getPrsData', variables],
      fetcher<GetPrsDataQuery, GetPrsDataQueryVariables>(GetPrsDataDocument, variables),
      options
    );
export const useInfiniteGetPrsDataQuery = <
      TData = GetPrsDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPrsDataQueryVariables,
      variables: GetPrsDataQueryVariables,
      options?: UseInfiniteQueryOptions<GetPrsDataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPrsDataQuery, TError, TData>(
      ['getPrsData.infinite', variables],
      (metaData) => fetcher<GetPrsDataQuery, GetPrsDataQueryVariables>(GetPrsDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetAssortmentDiffDocument = `
    query GetAssortmentDiff($input: GetAssortmentDiffInput!) {
  getAssortmentDiff(getAssortmentDiffInput: $input) {
    assortmentRecommendations {
      asin
      entryId
      startTime
      endTime
      subcategoryId
      macroplanogramId
      facingUnits
      fohCapacity
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        capacityUnitPerFacing {
          capacity
          errorMsg
          jumbleFactor
        }
        procurable
        buyable
        temperatureRating
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
      recommendedAction {
        action
        note
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetAssortmentDiffQuery = <
      TData = GetAssortmentDiffQuery,
      TError = unknown
    >(
      variables: GetAssortmentDiffQueryVariables,
      options?: UseQueryOptions<GetAssortmentDiffQuery, TError, TData>
    ) =>
    useQuery<GetAssortmentDiffQuery, TError, TData>(
      ['GetAssortmentDiff', variables],
      fetcher<GetAssortmentDiffQuery, GetAssortmentDiffQueryVariables>(GetAssortmentDiffDocument, variables),
      options
    );
export const useInfiniteGetAssortmentDiffQuery = <
      TData = GetAssortmentDiffQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAssortmentDiffQueryVariables,
      variables: GetAssortmentDiffQueryVariables,
      options?: UseInfiniteQueryOptions<GetAssortmentDiffQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAssortmentDiffQuery, TError, TData>(
      ['GetAssortmentDiff.infinite', variables],
      (metaData) => fetcher<GetAssortmentDiffQuery, GetAssortmentDiffQueryVariables>(GetAssortmentDiffDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetAssortmentSwapRecommendationsDocument = `
    query getAssortmentSwapRecommendations($input: GetAssortmentSwapRecommendationsInput!) {
  getAssortmentSwapRecommendations(getAssortmentSwapRecommendationsInput: $input) {
    facingUnitsToRemove
    maxFacingUnits
    occupiedFacingUnits
    swapRecommendations {
      asin
      entryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      storeId
      facingUnits
      fohCapacity
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
    }
  }
}
    `;
export const useGetAssortmentSwapRecommendationsQuery = <
      TData = GetAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      variables: GetAssortmentSwapRecommendationsQueryVariables,
      options?: UseQueryOptions<GetAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>
    useQuery<GetAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getAssortmentSwapRecommendations', variables],
      fetcher<GetAssortmentSwapRecommendationsQuery, GetAssortmentSwapRecommendationsQueryVariables>(GetAssortmentSwapRecommendationsDocument, variables),
      options
    );
export const useInfiniteGetAssortmentSwapRecommendationsQuery = <
      TData = GetAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAssortmentSwapRecommendationsQueryVariables,
      variables: GetAssortmentSwapRecommendationsQueryVariables,
      options?: UseInfiniteQueryOptions<GetAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getAssortmentSwapRecommendations.infinite', variables],
      (metaData) => fetcher<GetAssortmentSwapRecommendationsQuery, GetAssortmentSwapRecommendationsQueryVariables>(GetAssortmentSwapRecommendationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetBatchAssortmentSwapRecommendationsDocument = `
    query getBatchAssortmentSwapRecommendations($input: GetBatchAssortmentSwapRecommendationsInput!) {
  getBatchAssortmentSwapRecommendations(
    getBatchAssortmentSwapRecommendationsInput: $input
  ) {
    swapRecommendations {
      facingUnitsToRemove
      maxFacingUnits
      occupiedFacingUnits
      macroplanogramId
      swapRecommendations {
        asin
        entryId
        subcategoryId
        macroplanogramId
        startTime
        endTime
        storeId
        facingUnits
        fohCapacity
        asinMetadata {
          asin
          capacityUnitPerFacing {
            capacity
            errorMsg
          }
          title
          image
          uph {
            uphl1
            uphl2
            uphl3
          }
          performanceData {
            shrinkCost
            shrinkPerOps
            shrinkPerOps13week
            shrinkPerOps26week
            shrinkPerOps52week
            movingAvgSales13week
            movingAvgSales26week
            movingAvgSales52week
          }
        }
      }
    }
    errorMap {
      key
      error {
        errorMessage
        errorType
      }
    }
  }
}
    `;
export const useGetBatchAssortmentSwapRecommendationsQuery = <
      TData = GetBatchAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      variables: GetBatchAssortmentSwapRecommendationsQueryVariables,
      options?: UseQueryOptions<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>
    useQuery<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getBatchAssortmentSwapRecommendations', variables],
      fetcher<GetBatchAssortmentSwapRecommendationsQuery, GetBatchAssortmentSwapRecommendationsQueryVariables>(GetBatchAssortmentSwapRecommendationsDocument, variables),
      options
    );
export const useInfiniteGetBatchAssortmentSwapRecommendationsQuery = <
      TData = GetBatchAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetBatchAssortmentSwapRecommendationsQueryVariables,
      variables: GetBatchAssortmentSwapRecommendationsQueryVariables,
      options?: UseInfiniteQueryOptions<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getBatchAssortmentSwapRecommendations.infinite', variables],
      (metaData) => fetcher<GetBatchAssortmentSwapRecommendationsQuery, GetBatchAssortmentSwapRecommendationsQueryVariables>(GetBatchAssortmentSwapRecommendationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetCategoryDocument = `
    query GetCategory($input: GetCategoryInput) {
  getCategory(getCategoryInput: $input) {
    category {
      categoryId
      categoryName
      extraDimensions
    }
    subcategory {
      subcategoryId
      subcategoryName
      categoryId
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetCategoryQuery = <
      TData = GetCategoryQuery,
      TError = unknown
    >(
      variables?: GetCategoryQueryVariables,
      options?: UseQueryOptions<GetCategoryQuery, TError, TData>
    ) =>
    useQuery<GetCategoryQuery, TError, TData>(
      variables === undefined ? ['GetCategory'] : ['GetCategory', variables],
      fetcher<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, variables),
      options
    );
export const useInfiniteGetCategoryQuery = <
      TData = GetCategoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCategoryQueryVariables,
      variables?: GetCategoryQueryVariables,
      options?: UseInfiniteQueryOptions<GetCategoryQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetCategoryQuery, TError, TData>(
      variables === undefined ? ['GetCategory.infinite'] : ['GetCategory.infinite', variables],
      (metaData) => fetcher<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetFloorplanDocument = `
    query GetFloorplan($input: GetFloorplanInput!) {
  getFloorplan(getFloorplanInput: $input) {
    floorplans {
      floorplanId
      goLiveDate
      status
      fixtures {
        id
        model
        height
        width
        depth
        rotation
        translation
        department
        categories
        isAgile
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetFloorplanQuery = <
      TData = GetFloorplanQuery,
      TError = unknown
    >(
      variables: GetFloorplanQueryVariables,
      options?: UseQueryOptions<GetFloorplanQuery, TError, TData>
    ) =>
    useQuery<GetFloorplanQuery, TError, TData>(
      ['GetFloorplan', variables],
      fetcher<GetFloorplanQuery, GetFloorplanQueryVariables>(GetFloorplanDocument, variables),
      options
    );
export const useInfiniteGetFloorplanQuery = <
      TData = GetFloorplanQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetFloorplanQueryVariables,
      variables: GetFloorplanQueryVariables,
      options?: UseInfiniteQueryOptions<GetFloorplanQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetFloorplanQuery, TError, TData>(
      ['GetFloorplan.infinite', variables],
      (metaData) => fetcher<GetFloorplanQuery, GetFloorplanQueryVariables>(GetFloorplanDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMacroAssortmentDocument = `
    query GetMacroAssortment($input: GetMacroAssortmentInput!) {
  getMacroAssortment(getMacroAssortmentInput: $input) {
    assortment {
      asin
      entryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      storeId
      facingUnits
      fohCapacity
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
    }
    paginationToken
  }
}
    `;
export const useGetMacroAssortmentQuery = <
      TData = GetMacroAssortmentQuery,
      TError = unknown
    >(
      variables: GetMacroAssortmentQueryVariables,
      options?: UseQueryOptions<GetMacroAssortmentQuery, TError, TData>
    ) =>
    useQuery<GetMacroAssortmentQuery, TError, TData>(
      ['GetMacroAssortment', variables],
      fetcher<GetMacroAssortmentQuery, GetMacroAssortmentQueryVariables>(GetMacroAssortmentDocument, variables),
      options
    );
export const useInfiniteGetMacroAssortmentQuery = <
      TData = GetMacroAssortmentQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMacroAssortmentQueryVariables,
      variables: GetMacroAssortmentQueryVariables,
      options?: UseInfiniteQueryOptions<GetMacroAssortmentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMacroAssortmentQuery, TError, TData>(
      ['GetMacroAssortment.infinite', variables],
      (metaData) => fetcher<GetMacroAssortmentQuery, GetMacroAssortmentQueryVariables>(GetMacroAssortmentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMacroplanogramDocument = `
    query getMacroplanogram($input: GetMacroplanogramInput!) {
  getMacroplanogram(getMacroplanogramInput: $input) {
    macroplanogram {
      entryId
      macroplanogramName
      startTime
      endTime
      storeId
      storeSubcategories {
        subcategoryName
        subcategoryId
      }
      fixtureIds
      maxFacingUnits
      isCapacityOverrideAllowed
      isDraft
      zoneMapConfigId
    }
  }
}
    `;
export const useGetMacroplanogramQuery = <
      TData = GetMacroplanogramQuery,
      TError = unknown
    >(
      variables: GetMacroplanogramQueryVariables,
      options?: UseQueryOptions<GetMacroplanogramQuery, TError, TData>
    ) =>
    useQuery<GetMacroplanogramQuery, TError, TData>(
      ['getMacroplanogram', variables],
      fetcher<GetMacroplanogramQuery, GetMacroplanogramQueryVariables>(GetMacroplanogramDocument, variables),
      options
    );
export const useInfiniteGetMacroplanogramQuery = <
      TData = GetMacroplanogramQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMacroplanogramQueryVariables,
      variables: GetMacroplanogramQueryVariables,
      options?: UseInfiniteQueryOptions<GetMacroplanogramQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMacroplanogramQuery, TError, TData>(
      ['getMacroplanogram.infinite', variables],
      (metaData) => fetcher<GetMacroplanogramQuery, GetMacroplanogramQueryVariables>(GetMacroplanogramDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetProductGroupsDocument = `
    query GetProductGroups {
  getProductGroups {
    productGroups {
      productGroupId
      productGroupName
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetProductGroupsQuery = <
      TData = GetProductGroupsQuery,
      TError = unknown
    >(
      variables?: GetProductGroupsQueryVariables,
      options?: UseQueryOptions<GetProductGroupsQuery, TError, TData>
    ) =>
    useQuery<GetProductGroupsQuery, TError, TData>(
      variables === undefined ? ['GetProductGroups'] : ['GetProductGroups', variables],
      fetcher<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, variables),
      options
    );
export const useInfiniteGetProductGroupsQuery = <
      TData = GetProductGroupsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetProductGroupsQueryVariables,
      variables?: GetProductGroupsQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductGroupsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetProductGroupsQuery, TError, TData>(
      variables === undefined ? ['GetProductGroups.infinite'] : ['GetProductGroups.infinite', variables],
      (metaData) => fetcher<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetProgramStoresDocument = `
    query GetProgramStores {
  getProgramStores {
    stores {
      storeId
      warehouseId
      launchDate
    }
  }
}
    `;
export const useGetProgramStoresQuery = <
      TData = GetProgramStoresQuery,
      TError = unknown
    >(
      variables?: GetProgramStoresQueryVariables,
      options?: UseQueryOptions<GetProgramStoresQuery, TError, TData>
    ) =>
    useQuery<GetProgramStoresQuery, TError, TData>(
      variables === undefined ? ['GetProgramStores'] : ['GetProgramStores', variables],
      fetcher<GetProgramStoresQuery, GetProgramStoresQueryVariables>(GetProgramStoresDocument, variables),
      options
    );
export const useInfiniteGetProgramStoresQuery = <
      TData = GetProgramStoresQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetProgramStoresQueryVariables,
      variables?: GetProgramStoresQueryVariables,
      options?: UseInfiniteQueryOptions<GetProgramStoresQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetProgramStoresQuery, TError, TData>(
      variables === undefined ? ['GetProgramStores.infinite'] : ['GetProgramStores.infinite', variables],
      (metaData) => fetcher<GetProgramStoresQuery, GetProgramStoresQueryVariables>(GetProgramStoresDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetUserInformationDocument = `
    query getUserInformation {
  getUserInformation {
    alias
    allowedStyleMerchLocationGroup
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetUserInformationQuery = <
      TData = GetUserInformationQuery,
      TError = unknown
    >(
      variables?: GetUserInformationQueryVariables,
      options?: UseQueryOptions<GetUserInformationQuery, TError, TData>
    ) =>
    useQuery<GetUserInformationQuery, TError, TData>(
      variables === undefined ? ['getUserInformation'] : ['getUserInformation', variables],
      fetcher<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, variables),
      options
    );
export const useInfiniteGetUserInformationQuery = <
      TData = GetUserInformationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserInformationQueryVariables,
      variables?: GetUserInformationQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserInformationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserInformationQuery, TError, TData>(
      variables === undefined ? ['getUserInformation.infinite'] : ['getUserInformation.infinite', variables],
      (metaData) => fetcher<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetZoneMapConfigDocument = `
    query GetZoneMapConfig($input: GetZoneMapConfigInput!) {
  getZoneMapConfig(getZoneMapConfigInput: $input) {
    zoneMapConfig {
      name
      zones {
        name
        fixtures {
          id
          fixtureType
          facings
        }
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetZoneMapConfigQuery = <
      TData = GetZoneMapConfigQuery,
      TError = unknown
    >(
      variables: GetZoneMapConfigQueryVariables,
      options?: UseQueryOptions<GetZoneMapConfigQuery, TError, TData>
    ) =>
    useQuery<GetZoneMapConfigQuery, TError, TData>(
      ['GetZoneMapConfig', variables],
      fetcher<GetZoneMapConfigQuery, GetZoneMapConfigQueryVariables>(GetZoneMapConfigDocument, variables),
      options
    );
export const useInfiniteGetZoneMapConfigQuery = <
      TData = GetZoneMapConfigQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetZoneMapConfigQueryVariables,
      variables: GetZoneMapConfigQueryVariables,
      options?: UseInfiniteQueryOptions<GetZoneMapConfigQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetZoneMapConfigQuery, TError, TData>(
      ['GetZoneMapConfig.infinite', variables],
      (metaData) => fetcher<GetZoneMapConfigQuery, GetZoneMapConfigQueryVariables>(GetZoneMapConfigDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};
